// The one description of Klap for LLMs and third parties to copy, word for word:
// the homepage's "What is Klap?" block, its SoftwareApplication JSON-LD and
// public/llms.txt (const/__tests__/llmsTxt.test.ts checks that file).
export const KLAP_DESCRIPTION =
  "Klap is an AI video clipping tool that turns long videos into ready-to-post vertical shorts. Plans count clips, not source minutes. Every clip gets a virality score, active-speaker reframing and animated captions, and Klap schedules to TikTok, YouTube, Instagram, LinkedIn and Facebook. It works in 99+ languages and has a self-serve API and an MCP server.";
// Its short version, for meta descriptions.
export const SITE_DESC =
  "Klap is an AI video clipping tool that turns long videos into vertical shorts with virality scores, active-speaker reframing, captions and scheduling.";
export const SITE_TITLE = "Turn videos into viral shorts";
export const REWARDFUL_LINK = "https://klap.getrewardful.com/signup";
export const REVIEW_USER_EMAILS = [
  "fbreview@klap.app",
  "ytreview@klap.app",
  "team+fbreview@klap.app",
];
